/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch } from "react-redux"

import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BihinzaikoService from "../../../service/purchase/bihinzaiko/bihinzaikoService"
import {
  TBihinzaikoRirekiInfoGetRes,
  TBihinzaikoRirekiListGetReq,
} from "../../../service/purchase/bihinzaiko/TBihinzaiko"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"

import { e受払区分 } from "../../../constant/enum/zyutuHaisya"
import BusyoService from "../../../service/master/busyo/busyoService"
import dayjs from "dayjs"
import Decimal from "decimal.js"

/**
 * 備品在庫履歴一覧
 * @returns
 */
const PurchaseBihinzaikoRirekiList = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "PurchaseBihinzaikoHaraidasiHistoryList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TBihinzaikoRirekiInfoGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        払出金額: (i: TBihinzaikoRirekiInfoGetRes) => {
          const d払出単価 = new Decimal(i.払出単価 ?? 0)
          const d払出数量 = new Decimal(i.受払数量 ?? 0)

          return d払出単価.times(d払出数量).toNumber()
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TBihinzaikoRirekiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBihinzaikoRirekiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new BihinzaikoService().getRirekiList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBihinzaikoRirekiListGetReq = queryString.parse(
      location.search
    )
    set受払日開始(query.受払日From)
    set受払日終了(query.受払日To)
    set乗務員名(query.乗務員氏名)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBihinzaikoRirekiListGetReq => {
    return {
      受払日From: 受払日開始 ?? undefined,
      受払日To: 受払日終了 ?? undefined,
      乗務員氏名: 乗務員名 ?? undefined,
      部所コード: 部所コード ?? undefined,
      受払区分: e受払区分.払出,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBihinzaikoRirekiListGetReq
  ) => {
    const disp受払日開始 = searchCondition.受払日From
      ? dayjs(searchCondition.受払日From).format("YYYY/MM/DD")
      : ""
    const disp受払日終了 = searchCondition.受払日To
      ? dayjs(searchCondition.受払日To).format("YYYY/MM/DD")
      : ""

    return {
      受払日開始: wjCore.isNullOrWhiteSpace(disp受払日開始 ?? "")
        ? ""
        : disp受払日開始,
      受払日終了: wjCore.isNullOrWhiteSpace(disp受払日終了 ?? "")
        ? ""
        : disp受払日終了,
      乗務員名: wjCore.isNullOrWhiteSpace(searchCondition.乗務員氏名 ?? "")
        ? ""
        : searchCondition.乗務員氏名,
      部所コード: wjCore.isNullOrWhiteSpace(searchCondition.部所コード ?? "")
        ? ""
        : searchCondition.部所コード,
      // 受払区分ID: e受払区分.払出,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set受払日開始("")
    set受払日終了("")
    set部所コード(undefined)
    set乗務員名("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<string | null>()
  const [受払日開始, set受払日開始] = useState<string | null>()
  const [受払日終了, set受払日終了] = useState<string | null>()
  const [乗務員名, set乗務員名] = useState<string>()

  //#region [comboboxState]

  // 所属部所
  const [所属部所ComboBox, set所属部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [所属部所IsLoadEnded, set所属部所IsLoadEnded] = useState<boolean>(false)
  const [所属部所ItemSource, set所属部所ItemSource] = useState<T部所マスタ[]>() //#endregion

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `備品在庫払出履歴`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())

    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set所属部所ItemSource(部所ListRes.data)
    })
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">備品在庫払出履歴</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-13rem">
                              <DateInput
                                autoFocus
                                id="受払日開始"
                                has1DayButton={true}
                                value={受払日開始}
                                setValue={set受払日開始}
                                placeholder="払出日開始"
                              />
                            </div>
                            <div className="w-13rem">
                              <DateInput
                                id="受払日終了"
                                has1DayButton={true}
                                value={受払日終了}
                                setValue={set受払日終了}
                                placeholder="払出日終了"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <div className="w-20rem">
                              <ComboBox.Busyo
                                placeholder="部所"
                                listFilter={(d) => d.運行部所フラグ === 1}
                                isAllSelect
                                itemsSource={所属部所ItemSource}
                                isLoadEnded={所属部所IsLoadEnded}
                                setIsLoadEnded={set所属部所IsLoadEnded}
                                selectedValue={部所コード}
                                setSelectedValue={set部所コード}
                                ComboBox={所属部所ComboBox}
                                setComboBox={
                                  set所属部所ComboBox
                                }></ComboBox.Busyo>
                            </div>
                            <div className="w-13rem">
                              <TextInput
                                id="乗務員名"
                                name="乗務員名"
                                value={乗務員名}
                                setValue={set乗務員名}
                                maxLength={50}
                                style={{ width: "15rem" }}
                                placeholder="乗務員名"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <Row>
                    <Col xl={{ span: "auto", offset: 0 }}>
                      <Button
                        type="button"
                        variant="secondary"
                        onClick={() => history.goBack()}>
                        備品在庫一覧に戻る
                      </Button>
                    </Col>
                  </Row>
                }>
                <wjrGrid.FlexGridColumn
                  binding="受払日"
                  width={100}
                  header="払出日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TBihinzaikoRirekiInfoGetRes>
                    ) => {
                      let dt = ""
                      if (context.item.受払日)
                        dt = dayjs(context.item.受払日).format("YYYY/MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所コード"
                  width={100}
                  header="部所CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={150}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  header="乗務員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={120}
                  header="乗務員"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備品コード"
                  width={110}
                  header="備品CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備品名"
                  width={250}
                  header="品名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="サイズ"
                  width={100}
                  header="サイズ"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単位"
                  width={100}
                  header="単位"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ロット"
                  width={150}
                  header="ロット"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="払出単価"
                  width={100}
                  header="払出単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="受払数量"
                  width={100}
                  header="払出数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="払出金額"
                  width={100}
                  header="払出金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={300}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default PurchaseBihinzaikoRirekiList
